// @ts-nocheck
// Simplified from tailuge/billiards (GPL-3.0) — src/events/aimevent.ts
// Modified: data holder only. Removed GameEvent/Controller/network coupling.
import { Vector3 } from "three"

export class AimEvent {
  offset = new Vector3(0, 0, 0)
  angle = 0
  power = 0
  elevation = 0
  pos = new Vector3(0, 0, 0)
  i = 0

  copy(): AimEvent {
    const e = new AimEvent()
    e.pos.copy(this.pos)
    e.angle = this.angle
    e.offset.copy(this.offset)
    e.power = this.power
    e.elevation = this.elevation
    e.i = this.i
    return e
  }
}
